import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { NerdBadge, NerdSticker } from "./NerdBadge";

export function GuideCard({ guide, index = 0, wide = false }) {
  return (
    <Link
      to={`/setups/${guide.slug}`}
      id={guide.comment_word}
      className={`brand-card group relative flex flex-col overflow-visible no-underline fade-up transition-transform hover:-translate-y-1.5 hover:shadow-hero ${
        wide ? "sm:col-span-2" : ""
      }`}
      style={{ animationDelay: `${index * 60}ms` }}
      data-testid={`guide-card-${guide.slug}`}
    >
      {/* Nerd Scale sticker breaking out of the corner */}
      <div className="pointer-events-none absolute -right-3 -top-6 z-10 transition-transform group-hover:-translate-y-1 group-hover:rotate-6">
        <NerdSticker difficulty={guide.difficulty} width={wide ? 74 : 62} rotate={6} />
      </div>

      <div className={`flex flex-1 flex-col p-6 ${wide ? "md:p-8" : ""}`}>
        <span className="eyebrow !text-text-label">{guide.category}</span>

        {/* Comment-word hook */}
        <div className="mt-3 flex items-baseline gap-2">
          <span className="font-sans text-[11px] font-bold uppercase tracking-[0.16em] text-text-muted">comment</span>
          <span className={`hook-word text-ochre-hover ${wide ? "text-4xl" : "text-3xl"}`}>{guide.comment_word}</span>
        </div>

        <h3 className={`mt-4 text-navy ${wide ? "text-[26px] leading-tight" : "text-[20px] leading-tight"}`}>{guide.title}</h3>
        <p className={`mt-2 flex-1 text-text-muted ${wide ? "text-[15px] max-w-md" : "text-[14px]"}`}>{guide.short_desc}</p>

        <div className="mt-6 flex items-center justify-between border-t border-navy/10 pt-4">
          <NerdBadge difficulty={guide.difficulty} />
          <span className="font-sans inline-flex items-center gap-1 text-[13px] font-bold uppercase tracking-[0.12em] text-teal transition-transform group-hover:translate-x-1">
            Get it <ArrowUpRight size={15} />
          </span>
        </div>
      </div>
    </Link>
  );
}
